var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41761",
    "data-name": "Group 41761",
    transform: "translate(-17421 21949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41758",
    "data-name": "Group 41758",
    transform: "translate(16266 -22237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5451",
    "data-name": "Group 5451",
    transform: "translate(787 233)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(368 55)",
    fill: "#14b7dd",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41759",
    "data-name": "Group 41759",
    transform: "translate(17430.148 -21941.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33860",
    "data-name": "Group 33860",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33859",
    "data-name": "Group 33859",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143153",
    "data-name": "Path 143153",
    d: "M14.5,5.549a1.314,1.314,0,0,0-1.849.161L11.4,7.187V2.9a1.321,1.321,0,0,0-.41-.954L9.328.367A1.31,1.31,0,0,0,8.421.005H1.316A1.317,1.317,0,0,0,0,1.321V13.66a1.317,1.317,0,0,0,1.316,1.316h8.772A1.317,1.317,0,0,0,11.4,13.66v-2.4L14.663,7.4A1.315,1.315,0,0,0,14.5,5.549Zm-5.729-4.5c1.755,1.667,1.63,1.545,1.663,1.588H8.772ZM10.526,13.66a.439.439,0,0,1-.439.439H1.316a.439.439,0,0,1-.439-.439V1.321A.439.439,0,0,1,1.316.882H7.895V3.075a.439.439,0,0,0,.439.439h2.193V8.225L8.661,10.431a1.322,1.322,0,0,0-.272.54l-.408,1.706a.439.439,0,0,0,.6.5l1.61-.7a1.322,1.322,0,0,0,.333-.209ZM9.483,10.818l.672.564-.149.177a.44.44,0,0,1-.161.12l-.8.349.2-.853A.439.439,0,0,1,9.332,11Zm1.238-.107-.672-.563L12.473,7.28l.67.562Zm3.271-3.874-.282.334-.67-.562.283-.335a.437.437,0,0,1,.669.563Z",
    transform: "translate(0 -0.005)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33862",
    "data-name": "Group 33862",
    transform: "translate(1.754 2.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33861",
    "data-name": "Group 33861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143154",
    "data-name": "Path 143154",
    d: "M64.822,90H60.437a.439.439,0,1,0,0,.877h4.386a.439.439,0,0,0,0-.877Z",
    transform: "translate(-59.998 -90.003)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33864",
    "data-name": "Group 33864",
    transform: "translate(1.754 5.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33863",
    "data-name": "Group 33863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143155",
    "data-name": "Path 143155",
    d: "M67.454,181H60.437a.439.439,0,0,0,0,.877h7.017a.439.439,0,0,0,0-.877Z",
    transform: "translate(-59.998 -181.001)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33866",
    "data-name": "Group 33866",
    transform: "translate(1.754 7.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33865",
    "data-name": "Group 33865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143156",
    "data-name": "Path 143156",
    d: "M67.454,271H60.437a.439.439,0,1,0,0,.877h7.017a.439.439,0,0,0,0-.877Z",
    transform: "translate(-59.998 -271)",
    fill: "#76747f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33868",
    "data-name": "Group 33868",
    transform: "translate(1.754 10.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33867",
    "data-name": "Group 33867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143157",
    "data-name": "Path 143157",
    d: "M64.822,361H60.437a.439.439,0,1,0,0,.877h4.386a.439.439,0,0,0,0-.877Z",
    transform: "translate(-59.998 -360.998)",
    fill: "#76747f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrNoteIcon);
export default __webpack_public_path__ + "static/media/TRNoteIcon.6cfe1e771927705195e33d950cfa916f.svg";
export { ForwardRef as ReactComponent };